import { SharedModule } from './../shared/shared.module';
import { NgxPermissionsModule } from 'ngx-permissions';
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// NgBootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translation
import { TranslateModule } from '@ngx-translate/core';
// Loading bar
import { LoadingBarModule } from '@ngx-loading-bar/core';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// Ngx DatePicker

// Perfect Scrollbar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
// Core Module
import { CoreModule } from '../../../core/core.module';
import { HeaderComponent } from './header/header.component';
import { AsideLeftComponent } from './aside/aside-left.component';
import { FooterComponent } from './footer/footer.component';
import { SubheaderComponent } from './subheader/subheader.component';
import { BrandComponent } from './header/brand/brand.component';
import { TopbarComponent } from './header/topbar/topbar.component';
import { MenuHorizontalComponent } from './header/menu-horizontal/menu-horizontal.component';
import { PartialsModule } from '../../partials/partials.module';
import { BaseComponent } from './base/base.component';
import { HtmlClassService } from './html-class.service';
import { HeaderMobileComponent } from './header/header-mobile/header-mobile.component';
import { PermissionEffects } from '../../../core/auth';
import { AccountService } from "./../account/services/account.service";
import { PurchaseComponent } from './pages/purchase/purchase.component';
import { PurchaseRoutingModule } from './purchase-routing.module';
import {
  MatAutocompleteModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatInputModule,
  MatRadioModule,
  MatButtonModule,
  MatCardModule,
  MatChipsModule,
  MatSelectModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatIconModule,
  MatSliderModule,
  MatPaginatorModule,
  MatSortModule,
  MatSidenavModule,
  MatSnackBarModule,
  MatStepperModule,
  MatToolbarModule,
  MatDividerModule,
  MatTabsModule,
  MatTableModule,
  MatTooltipModule,
  MatListModule,
  MatGridListModule,
  MatButtonToggleModule,
  MatBottomSheetModule,
  MatExpansionModule,
  _MatChipListMixinBase,
  MatMenuModule,
  MatTreeModule,
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MatDialogModule,
  MatRippleModule,
  MatCheckboxModule,
  MatSlideToggleModule,
  MatDatepickerModule,
  DateAdapter

} from "@angular/material";
import { MassPurchaseComponent } from './pages/mass-purchase/mass-purchase.component';
import { MassPurchaseGuard } from './guards/massPurchaseGuard';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { RenewComponent } from './pages/renew/renew.component';
import { ResellerSignupComponent } from './pages/reseller-signup/reseller-signup.component';
import { StepperArrowComponent } from './pages/reseller-signup/stepper-arrow/stepper-arrow.component';
import { PhoneNumberFormCompComponent } from './pages/reseller-signup/phone-number-form-comp/phone-number-form-comp.component';
import { UserInfoFormCompComponent } from './pages/reseller-signup/user-info-form-comp/user-info-form-comp.component';
import { SellerInfoFormCompComponent } from './pages/reseller-signup/seller-info-form-comp/seller-info-form-comp.component';
import { MaterialPersianDateAdapter, PERSIAN_DATE_FORMATS } from '../shared/material.persian-date.adapter';
import { LoginPasswordCompComponent } from './pages/reseller-signup/login-password-comp/login-password-comp.component';
import { NewPurchaseComponent } from './pages/new-purchase/new-purchase.component';
import { RegisterUserCompComponent } from './pages/reseller-signup/register-user-comp/register-user-comp.component';
import { ResellerStatusComponent } from './pages/reseller-signup/reseller-status/reseller-status.component';
import { UpdateResellerComponent } from './pages/reseller-signup/update-reseller/update-reseller.component';
import { PurchasePlanComponent } from './pages/purchase-plan/purchase-plan.component';
import { NewPurchase2Component } from './pages/new-purchase2/new-purchase2.component';
@NgModule({
  declarations: [BaseComponent,
    FooterComponent,

    // headers
    HeaderComponent,
    BrandComponent,
    HeaderMobileComponent,

    // subheader
    SubheaderComponent,

    // topbar components
    TopbarComponent,

    // aside left menu components
    AsideLeftComponent,

    // horizontal menu components
    MenuHorizontalComponent,


    PurchaseComponent,

    MassPurchaseComponent,

    RenewComponent,
    ResellerSignupComponent,
    StepperArrowComponent,
    PhoneNumberFormCompComponent,
    UserInfoFormCompComponent,
    SellerInfoFormCompComponent,
    LoginPasswordCompComponent,
    NewPurchaseComponent,
    RegisterUserCompComponent,
    ResellerStatusComponent,
    UpdateResellerComponent,
    PurchasePlanComponent,
    NewPurchase2Component,
  ],
  exports: [
    BaseComponent,
    FooterComponent,

    // headers
    HeaderComponent,
    BrandComponent,
    HeaderMobileComponent,

    // subheader
    SubheaderComponent,

    // topbar components
    TopbarComponent,

    // aside left menu components
    AsideLeftComponent,

    // horizontal menu components
    MenuHorizontalComponent,

  ], providers: [
    {
      provide: DateAdapter,
      useClass: MaterialPersianDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: PERSIAN_DATE_FORMATS },
    HtmlClassService, AccountService, MassPurchaseGuard
  ],
  imports: [
    CommonModule,
    RouterModule,
    PurchaseRoutingModule,
    PartialsModule,
    CoreModule,
    PerfectScrollbarModule,
    NgbModule,
    FormsModule,
    MatProgressBarModule,
    MatTabsModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule.forChild(),
    LoadingBarModule,
    NgxDaterangepickerMd,
    InlineSVGModule,
    // material modules
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatListModule,
    MatSliderModule,
    MatCardModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatMenuModule,
    MatTabsModule,
    MatTooltipModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTableModule,
    MatGridListModule,
    MatToolbarModule,
    MatBottomSheetModule,
    MatExpansionModule,
    MatDividerModule,
    MatSortModule,
    MatStepperModule,
    MatChipsModule,
    MatPaginatorModule,
    MatDialogModule,
    MatRippleModule,
    CoreModule,
    CommonModule,
    MatRadioModule,
    MatTreeModule,
    MatButtonToggleModule,
    PartialsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class PurchaseModule { }
